import {NavList, VisuallyHidden} from '@primer/react'
import type {Ref} from 'react'
import styles from './SessionsNavListShowAction.module.css'

interface SessionsNavListShowActionProps {
  onClick: () => void
  children: React.ReactNode
  hiddenLabel: string
  ref?: Ref<HTMLButtonElement>
}

export const SessionsNavListShowAction = ({
  onClick,
  children,
  hiddenLabel,
  ref,
  ...props
}: SessionsNavListShowActionProps) => (
  <NavList.Item className={styles.showItem} as="button" ref={ref} data-has-subitem="false" onClick={onClick} {...props}>
    <span className={styles.showLabel}>
      <span>{children}</span>
      <VisuallyHidden> {hiddenLabel}</VisuallyHidden>
    </span>
  </NavList.Item>
)
